//@flow
import {
  HISTORY_PAYMENTS,
  HISTORY_PAYMENTS_PROCESSED,
  HISTORY_PAYMENTS_COMPLETED,
  AUTH_TOKEN_KEY,
  ASCENDING,
  DESCENDING,
  INC_DATA_PEMBELIAN,
  INC_DATA_PEMBELIAN_PROCESSED,
  INC_DATA_PEMBELIAN_COMPLETED,
  ACTION_SELLER_SELL,
  UPDATE_LISTING_EXPIRY,
  // UPDATE_BULK_RENEW,
  AWB_SENT_KA,
  BUY_COMPLETIONS,
  // HISTORY_SELLS_PENDING,
  LIST_SELLING,
  LIST_SELLING_PENDING,
  LIST_SELLING_HISTORY,
  HOLIDAY_MODE_REQUEST,
  SELLER_INPUT_AWB,
  FETCH_SHIPPING_TRACKING,
  UPLOAD_IMAGE_S3,
  GET_SELLING_COMMISSION_FEE_SETTING,
} from "../constants";
import { UPDATE_BULK_RENEW } from "../constants/saleConstants";
import fetch from "../utils/Api";

export const historyPayments = query => ({
  type: HISTORY_PAYMENTS,
  payload: fetch({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
  })
    .get("/users/payments", { params: { ...query } })
    .then(response => response.data)
});

export const _doASC = _header => ({
  type: ASCENDING,
  payload: _header
});

export const _doDESC = _header => ({
  type: DESCENDING,
  payload: _header
});

export const _moreDataPembelian = (next_page, ascDesc, reset) => ({
  type: INC_DATA_PEMBELIAN,
  payload: fetch({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
  })
    .get(`/users/payments?page=${next_page}`)
    .then(res => ({ ...res.data, ascDesc, reset }))
});

/* API for second tab (pembelian) */

export const historyPaymentsProcessed = query => ({
  type: HISTORY_PAYMENTS_PROCESSED,
  payload: fetch({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
  })
    .get("/users/payments", { params: { status: "processed", ...query } })
    .then(response => response.data)
});

export const _moreDataPembelianProcessed = (next_page, ascDesc, reset) => ({
  type: INC_DATA_PEMBELIAN_PROCESSED,
  payload: fetch({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
  })
    .get(`/users/payments?status=processed&page=${next_page}`)
    .then(res => ({ ...res.data, ascDesc, reset }))
});

export const historyPaymentsCompleted = query => ({
  type: HISTORY_PAYMENTS_COMPLETED,
  payload: fetch({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
  })
    .get("/users/payments", { params: { status: "history", ...query } })
    .then(response => response.data)
});

export const _moreDataPembelianCompleted = (next_page, ascDesc, reset) => ({
  type: INC_DATA_PEMBELIAN_COMPLETED,
  payload: fetch({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
  })
    .get(`/users/payments?status=history&page=${next_page}`)
    .then(res => ({ ...res.data, ascDesc, reset }))
});

/*yang dibawah tinggal di aktifin aja sembari nunggu api sopyan*/
export const listSelling = (query, ascDesc = true) => ({
  type: LIST_SELLING,
  payload: fetch({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
  })
    .get(`/users/selling/sells`, query)
    .then(res => ({ ...res.data, ascDesc }))
});

export const processSelling = (query, ascDesc = true) => ({
  type: LIST_SELLING_PENDING,
  payload: fetch({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
  })
    .get(`/users/process/sells`, query)
    .then(res => ({ ...res.data, ascDesc }))
});

export const historySelling = (query, ascDesc = true) => ({
  type: LIST_SELLING_HISTORY,
  payload: fetch({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
  })
    .get(`/users/history/sells`, query)
    .then(res => ({ ...res.data, ascDesc }))
});

export const actionSellerSell = (ActionBool, saleId) => ({
  type: ACTION_SELLER_SELL,
  payload: fetch({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
  })
    .put(`/users/sales/${ActionBool ? "approvals" : "cancellations"}/${saleId}`)
    .then(res => res.data)
});

export const actionInputAWB = (
  saleId,
  seller_courier,
  AWB_number,
  awb_image
) => {
  let payload = new FormData();
  payload.append("seller_courier", seller_courier)
  payload.append("seller_awb_number", AWB_number);

  if (awb_image.length > 0) {
    payload.append("seller_awb_image", awb_image[0]);
  }

  return {
    type: SELLER_INPUT_AWB,
    payload: fetch({
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`,
      "Content-Type": "multipart/form-data"
    })
      .post(`/users/orders/${saleId}/awb-number`, payload)
      .then(res => res.data)
  };
};

export const doBuyCompletions = (id) => ({
  type: BUY_COMPLETIONS,
  payload: fetch({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
  })
    .put(`/users/orders/${id}/completions`)
    .then(res => res.data)
});

export const doListingExpiry = (id, payload) => ({
  type: UPDATE_LISTING_EXPIRY,
  payload: fetch({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
  })
    .put(`/users/sells/${id}/extend`, payload)
    .then(res => res.data)
});

export const doBulkRenew = payload => ({
  type: UPDATE_BULK_RENEW,
  payload: fetch({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
  })
    .put(`/users/sells/extend-bulk`, payload)
    .then(res => res.data)
});

export const submitHolidayMode = payload => ({
  type: HOLIDAY_MODE_REQUEST,
  payload: fetch({
    Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY)
  })
    .put(`sellers/holiday_mode`, payload)
    .then(res => res.data)
});

export const fetchShippingTracking = (sale_id, query = {}) => ({
  type: FETCH_SHIPPING_TRACKING,
  payload: fetch({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
  }).get(`users/orders/${sale_id}/tracking-shipment`, { params: { ...query } })
    .then(response => response.data)
})

export const uploadImageToS3 = (file) => {
  return fetch({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
  })
    .post(`/users/asset_uploads`, file)
    .then(res => res.data.data)
};

export const settleWithKickCredit = () => {
  return {
    type: "SETTLE_WITH_KICK_CREDIT",
    payload: fetch({
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
    })
    .post(`/users/payments/settle-credit`, {})
      .then(res => res)
      .catch(err => console.log(err, "ERROR Action settleWithKickCredit"))
  }
};

export const getSellingCommissionSetting = () => {
  return {
    type: GET_SELLING_COMMISSION_FEE_SETTING,
    payload: fetch({
      Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY)
    })
      .get(`/settings?name=selling_commission_fee`)
      .then(response => response.data)
  }
}
